// extracted by mini-css-extract-plugin
export default {"MONTH":"PwtyA3","month":"PwtyA3","DAY":"FVnyEb","day":"FVnyEb","YEAR":"iEjp3V","year":"iEjp3V","fields":"xIkPSz","mobile":"UlxDyK"};